<template>
  <el-table
    :empty-text="$t('NO_DATA')"
    :data="tableData.results"
    v-loading="loading"
    :stripe="true"
    :default-sort="{ prop: 'id', order: 'descending' }"
    style="width: 100%"
  >
    <el-table-column
      sortable
      type="index"
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('INDEX')"
      width="60"
    >
      <template slot-scope="scope">
        <div :data-title="$t('INDEX')">
          {{ scope.$index + 1 }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      v-if="type == 'drivers'"
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('FULL_NAME')"
      width="180"
    >
      <template slot-scope="scope">
        <div :data-title="$t('FULL_NAME')" v-if="scope.row.driver != undefined">
          {{ scope.row.driver.first_name + ' ' + scope.row.driver.last_name }}
        </div>
      </template>
    </el-table-column>

    <el-table-column
      v-if="type == 'company-vehicle-services'"
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('SERVICE')"
      width="100"
    >
      <template slot-scope="scope">
        <div
          :data-title="$t('SERVICE')"
          v-if="scope.row.company_vehicle_service != undefined"
        >
          {{
            $i18n.locale == 'fa'
              ? scope.row.company_vehicle_service.service.fa_title
              : scope.row.company_vehicle_service.service.en_title
          }}
        </div>
      </template>
    </el-table-column>

    <el-table-column
      v-if="type == 'company-vehicle-services'"
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('VEHICLE_TITLE')"
      width="150"
    >
      <template slot-scope="scope">
        <LicensePlate
          v-if="scope.row.company_vehicle_service != undefined"
          :vehicle="scope.row.company_vehicle_service.company_vehicle.vehicle"
          :license_plate="
            scope.row.company_vehicle_service.company_vehicle.license_plate
          "
          :chars="alpha"
        >
        </LicensePlate>
      </template>
    </el-table-column>

    <el-table-column
      v-if="type == 'comapny-vehicles'"
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('VEHICLE_TITLE')"
      width="150"
    >
      <template slot-scope="scope">
        <LicensePlate
          v-if="scope.row.company_vehicle != undefined"
          :vehicle="scope.row.company_vehicle.vehicle"
          :license_plate="scope.row.company_vehicle.license_plate"
          :chars="alpha"
        >
        </LicensePlate>
      </template>
    </el-table-column>

    <el-table-column
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('TYPE')"
      width="180"
    >
      <template slot-scope="scope">
        <div :data-title="$t('TYPE')" class="flex">
          {{
            $i18n.locale == 'fa'
              ? scope.row.type.fa_title
              : scope.row.type.en_title
          }}
        </div>
      </template>
    </el-table-column>

    <el-table-column
      :align="$i18n.locale == 'fa' ? 'right' : 'left'"
      :label="$t('DATE_')"
      width="120"
    >
      <template slot-scope="scope">
        <div :data-title="$t('DATE_')">
          <span v-if="$i18n.locale == 'fa'">
            {{ scope.row.date | getPersianDate }}
          </span>
          <span v-else>
            {{ scope.row.date }}
          </span>
        </div>
      </template>
    </el-table-column>

    <el-table-column align="center" :label="$t('VIEW_PROFILE')" width="100">
      <template slot-scope="scope">
        <div :data-title="$t('VIEW_PROFILE')">
          <a
            v-if="type == 'drivers' && scope.row.driver != undefined"
            target="_blank"
            :href="'/drivers/view/' + scope.row.driver.id"
          >
            <i class="el-icon-view text-xl cursor-pointer text-purple-700"></i>
          </a>
          <a
            v-else-if="
              type == 'company-vehicle-services' &&
              scope.row.company_vehicle_service != undefined
            "
            target="_blank"
            :href="'/service/view/' + scope.row.company_vehicle_service.id"
          >
            <i class="el-icon-view text-xl cursor-pointer text-purple-700"></i>
          </a>

          <a
            v-else-if="
              type == 'comapny-vehicles' &&
              scope.row.company_vehicle != undefined
            "
            target="_blank"
            :href="'/cars/view/' + scope.row.company_vehicle.id"
          >
            <i class="el-icon-view text-xl cursor-pointer text-purple-700"></i>
          </a>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import LicensePlate from '@/components/cars/LicensePlate'
export default {
  props: ['tableData', 'loading', 'type', 'alpha'],
  components: {
    LicensePlate,
  },
}
</script>

<style lang="scss">
.message {
  b {
    direction: ltr;
    margin: 0 2px;
    display: inline-block;
  }
}
</style>
